module.exports = __webpack_public_path__ + "fonts/ralewayblackitalic.9365974.ttf";